export enum NotificationType {
    AskAppointment = 1,
    Appointment = 2,
}
